import LoaderModal from './loader-modal.vue';

export default LoaderModal;
